import { render, staticRenderFns } from "./injury-grade.vue?vue&type=template&id=1bcded41&scoped=true"
import script from "./injury-grade.vue?vue&type=script&lang=js"
export * from "./injury-grade.vue?vue&type=script&lang=js"
import style0 from "./injury-grade.vue?vue&type=style&index=0&id=1bcded41&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcded41",
  null
  
)

export default component.exports